import store from '@/store'
import actions from '@/store/actions'

export const getPaymentCertificate = async (contractId) => {
  const paymentCertificate = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/payments/certificate`,
      method: 'GET'
    }
  )
  return paymentCertificate
}

export const createPaymentCertificate = async (contractId, body) => {
  const paymentCertificate = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/payments/certificate`,
      method: 'POST',
      body
    }
  )
  return paymentCertificate
}

export const updatePaymentCertificate = async (contractId, certificateId, body) => {
  const paymentCertificate = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/payments/certificate/${certificateId}`,
      method: 'PUT',
      body
    }
  )
  return paymentCertificate
}

export const deletePaymentCertificate = async (contractId, certificateId) => {
  const paymentCertificate = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/payments/certificate/${certificateId}`,
      method: 'DELETE'
    }
  )
  return paymentCertificate
}

export const createPaymentCertificateRow = async (contractId, certificateId, body) => {
  const paymentCertificate = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/payments/certificate/${certificateId}/row`,
      method: 'POST',
      body
    }
  )
  return paymentCertificate
}

export const updatePaymentCertificateRow = async (contractId, certificateId, rowId, body) => {
  const paymentCertificate = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/payments/certificate/${certificateId}/row/${rowId}`,
      method: 'PUT',
      body
    }
  )
  return paymentCertificate
}

export const deletePaymentCertificateRow = async (contractId, certificateId, rowId) => {
  const paymentCertificate = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/payments/certificate/${certificateId}/row/${rowId}`,
      method: 'DELETE'
    }
  )
  return paymentCertificate
}
